import { type ApplicantGroupType } from '@exam-center/graphql';
import { SectionTitle, Divider } from '@shared/components';

import { BasicInformationReadonlyField } from '../basic-information-readonly-field';
import { ExamCoursesReadonlyField } from '../exam-courses-readonly-field';
import {
  ExamScheduleReadonlyField,
  type ExamScheduleReadonlyFieldProps,
} from '../exam-schedule-readonly-field';
import { LocationReadonlyField } from '../location-readonly-field';
import { OptionalInformationReadonlyField } from '../optional-information-readonly-field';

export interface ExamEventInformationReadonlyFieldsProps {
  slotProps: {
    province?: {
      province: string;
      location: string;
    };
    name?: string;
    room?: {
      roomData: {
        name: string;
        seat: number;
        floor: string;
        roomNumber: string | null;
        building: string;
      }[];
    };
    numberOfExaminees?: number;
    examType?: {
      icon: JSX.Element;
      label: string;
      checked: boolean;
    }[];
    registrationType?: {
      icon: JSX.Element;
      label: string;
      checked: boolean;
    }[];
    examCourses?: {
      courses?: string[];
      isAllSelected?: boolean;
    };
    applicantGroup?: {
      code: string;
      type: ApplicantGroupType;
    };
    seat?: number;
  } & ExamScheduleReadonlyFieldProps;
}

export default function ExamEventInformationReadonlyFields(
  props: Readonly<ExamEventInformationReadonlyFieldsProps>,
) {
  const { slotProps } = props;

  return (
    <>
      <SectionTitle title='Basic Information' />
      <BasicInformationReadonlyField
        examEventName={slotProps?.name ?? ''}
        examType={slotProps?.examType ?? []}
        registrationType={slotProps?.registrationType ?? []}
      />
      <Divider />
      <SectionTitle title='Exam Courses' />
      <ExamCoursesReadonlyField
        courses={slotProps?.examCourses?.courses}
        isAllSelected={slotProps?.examCourses?.isAllSelected}
      />
      <Divider />
      <SectionTitle title='Exam Schedule' />
      <ExamScheduleReadonlyField examDate={slotProps.examDate} sessions={slotProps.sessions} />
      <Divider />
      <SectionTitle title='Exam Location' />
      <LocationReadonlyField slotProps={slotProps} isSeatEditable={false} />
      <Divider />
      <SectionTitle title='Optional Information' />
      <OptionalInformationReadonlyField slotProps={slotProps} />
    </>
  );
}
